import { DatabaseRecord } from "@/core/repos/table.repo";
import { FeeLadderModel } from "./fee-ladder.model";

export interface FeeLadderLevelModel extends DatabaseRecord {
    code?: string | null;
    name: string;
    fromAmount: number;
    toAmount: number;
    feeLadderId: string;
    price: number;
    provinceId: string;
    waterFactoryId: string;
    createdAt?: Date;
    updatedAt?: Date;
    createdBy?: string;
    updatedBy?: string;
}

export class FeeLadderLevelModelFactory {
    static getEmpty(model?: FeeLadderModel): FeeLadderLevelModel {
        return {
            id: "",
            code: "",
            name: "",
            fromAmount: 0,
            toAmount: 0,
            feeLadderId: model?.id??"",
            price: 0,
            provinceId: model?.provinceId??"",
            waterFactoryId: "",
            createdAt: new Date(),
            updatedAt: new Date(),
            createdBy: "",
            updatedBy: ""
        };
    }
}
